import React from 'react';
import Dashboard from '../features/dashboard/pages/Dashboard';

const Main = () => {
  return <Dashboard />;
};

export default Main;

